/* eslint-disable react/prop-types */
import React, { useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import { Form, Input, Row, Col, notification, Spin } from 'antd';
import { Button as CrceButton } from '@crc-evans/ui-components';
import { Check, Loader2, Trash2, X } from 'lucide-react';
import '../ShippingManagement/ShipmentDashBoardPage.css';
import './PQTTestPage.css';
import PqtFormSelect from './PqtFormSelect';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { addStation, deleteSowStation } from '../../redux/stationDetails/action';

const AddNewPQTStation = (props) => {
  const {
    isModalVisible,
    setIsModalVisible,
    isNewStationLoading,
    isStationsLoading,
    isStationsDeleteLoading,
    stationList,
    setStationList,
    onSave,
    editStationForm,
    loadingBtn,
    setLoadingBtn,
    onAddStation,
    antIcon,
    onDeleteStationList,
  } = props;

  const [selectedStation, setSelectedStation] = useState(null);
  const [newStation, setNewStation] = useState(null);
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [deleteStationList, setDeleteStationList] = useState('');

  const stationSelectOptions = useMemo(() => {
    if (!stationList || !stationList.length) return [];
    const rev = [...stationList].reverse();
    return rev.map((item, i) => ({
      value: item.name,
      label: item.name,
      deletable: i < stationList.length - 4,
      station: item,
    }));
  }, [stationList]);

  const handleOk = () => {
    editStationForm.validateFields().then(async (data) => {
      if (data.stationName && data.customStationName) {
        setLoadingBtn(true);
        await onSave(selectedStation, data.customStationName);
        setLoadingBtn(false);
        setIsModalVisible(false);
        editStationForm.resetFields();
        setSelectedStation(null);
      } else {
        notification.warning({
          message: 'Select all required fields to proceed!',
        });
      }
    });
  };

  const handleCancel = () => {
    editStationForm.resetFields();
    setIsModalVisible(false);
    setSelectedStation(null);
    setIsDeleteModal(false);
    setDeleteStationList('');
  };

  const onAddNewStation = (event) => {
    setNewStation(event.target.value);
  };

  const addItem = async (e) => {
    e.preventDefault();
    if (!isEmpty(newStation) && !isEmpty(newStation.trim())) {
      const stationData = {
        name: newStation,
        imageUrl: 'NULL',
      };
      await onAddStation(stationData);

      setNewStation('');

      //for local only
      // var arr = [...stationList];
      // arr.push(stationData)
      // setStationList(arr);
    }
  };

  const removeItem = (e) => {
    e.preventDefault();
    setNewStation('');
  };

  const stationTypeMenuFooter = useMemo(
    () => (
      <div className="pqt-station-select-footer">
        <input
          type="text"
          className="pqt-station-select-footer-input"
          placeholder="Add new station type"
          value={newStation || ''}
          onChange={onAddNewStation}
          disabled={isNewStationLoading}
          onClick={(e) => e.stopPropagation()}
          autoComplete="off"
        />
        <div className="pqt-station-select-footer__actions">
          {isNewStationLoading ? (
            <Spin indicator={<Loader2 className="pqt-inline-spin" size={18} aria-hidden />} />
          ) : (
            <>
              <button
                type="button"
                className="pqt-station-select-footer__btn pqt-station-select-footer__btn--ok"
                aria-label="Add station type"
                onMouseDown={(e) => e.stopPropagation()}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  addItem(e);
                }}
              >
                <Check size={18} strokeWidth={2} aria-hidden />
              </button>
              <button
                type="button"
                className="pqt-station-select-footer__btn pqt-station-select-footer__btn--clear"
                aria-label="Clear"
                onMouseDown={(e) => e.stopPropagation()}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  removeItem(e);
                }}
              >
                <X size={18} strokeWidth={2} aria-hidden />
              </button>
            </>
          )}
        </div>
      </div>
    ),
    [newStation, isNewStationLoading]
  );

  return (
    <>
      {isModalVisible &&
        typeof document !== 'undefined' &&
        createPortal(
          <>
            <div
              className="mc-dpr-modal-backdrop mc-dpr-modal-backdrop--add-test mc-dpr-modal-backdrop--pqt-station-portal"
              role="presentation"
              onClick={handleCancel}
            >
              <div
                className="mc-dpr-modal mc-dpr-modal--medium"
                role="dialog"
                aria-labelledby="pqt-add-station-title"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="mc-dpr-modal-head">
                  <h3 id="pqt-add-station-title" className="mc-dpr-modal-title">
                    Add station
                  </h3>
                  <button
                    type="button"
                    className="mc-dpr-modal-close"
                    aria-label="Close"
                    onClick={handleCancel}
                  >
                    <X size={20} strokeWidth={2} aria-hidden />
                  </button>
                </div>
                <div className="mc-dpr-modal-body">
                  <Form
                    form={editStationForm}
                    name="pqt-add-station"
                    layout="vertical"
                    autoComplete="off"
                    onValuesChange={(changed) => {
                      if (changed.stationName !== undefined) {
                        const name = changed.stationName;
                        const stationData = (stationList || []).find((u) => u.name === name);
                        setSelectedStation(stationData || null);
                      }
                    }}
                  >
                    <Row gutter={16}>
                      <Col lg={24}>
                        <Form.Item
                          label="Station Type"
                          name="stationName"
                          required
                          getValueFromEvent={(v) => v}
                          rules={[{ required: true, message: 'Select a station type' }]}
                        >
                          <PqtFormSelect
                            disabled={isStationsDeleteLoading}
                            placeholder="Select station type…"
                            options={stationSelectOptions}
                            menuFooter={stationTypeMenuFooter}
                            renderOptionExtra={(opt) =>
                              opt.deletable ? (
                                <button
                                  type="button"
                                  className="pqt-station-type-delete-btn"
                                  aria-label={`Delete station type ${opt.label}`}
                                  onMouseDown={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setIsDeleteModal(true);
                                    setDeleteStationList(opt.station);
                                  }}
                                >
                                  <Trash2 size={16} strokeWidth={2} aria-hidden />
                                </button>
                              ) : null
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col lg={24}>
                        <Form.Item
                          label="Station Name"
                          name="customStationName"
                          required
                          rules={[{ required: true, message: 'Enter station name' }]}
                        >
                          <Input size="large" placeholder="Station name" />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form>
                  <p className="pqt-station-add-hint">
                    Please add pipeline in Details tab to Select Pipeline here (if not added yet).
                  </p>
                </div>
                <div className="mc-dpr-modal-foot">
                  <CrceButton label="Cancel" variant="tertiary" size="medium" onClick={handleCancel} />
                  <CrceButton label="Add" variant="primary" size="medium" onClick={handleOk} />
                </div>
              </div>
            </div>

            {isDeleteModal && (
              <div
                className="mc-dpr-modal-backdrop mc-dpr-modal-backdrop--nested mc-dpr-modal-backdrop--pqt-station-portal-nested"
                role="presentation"
                onClick={() => {
                  setIsDeleteModal(false);
                  setDeleteStationList('');
                }}
              >
                <div
                  className="mc-dpr-modal mc-dpr-modal--narrow mc-dpr-modal--delete"
                  role="dialog"
                  aria-labelledby="pqt-delete-station-type-title"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="mc-dpr-modal-head">
                    <h3 id="pqt-delete-station-type-title" className="mc-dpr-modal-title">
                      Delete station type
                    </h3>
                    <button
                      type="button"
                      className="mc-dpr-modal-close"
                      aria-label="Close"
                      onClick={() => {
                        setIsDeleteModal(false);
                        setDeleteStationList('');
                      }}
                    >
                      <X size={20} strokeWidth={2} aria-hidden />
                    </button>
                  </div>
                  <div className="mc-dpr-modal-body">
                    <div className="mc-dpr-modal-delete-body">
                      <p className="mc-dpr-modal-delete-lead">
                        Deleting this station type will delete all associated data (SOW stations, tests and
                        welds).
                      </p>
                      <p className="mc-dpr-modal-delete-target">{deleteStationList && deleteStationList.name}</p>
                      <p className="mc-dpr-modal-delete-warning">This action cannot be undone.</p>
                    </div>
                  </div>
                  <div className="mc-dpr-modal-foot">
                    <CrceButton
                      label="Cancel"
                      variant="tertiary"
                      size="medium"
                      onClick={() => {
                        setIsDeleteModal(false);
                        setDeleteStationList('');
                      }}
                    />
                    <CrceButton
                      label="Delete"
                      variant="primary"
                      size="medium"
                      onClick={async () => {
                        await onDeleteStationList({ data: deleteStationList });
                        setIsDeleteModal(false);
                        setDeleteStationList('');
                        setNewStation('');
                        editStationForm.resetFields();
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
          </>,
          document.body
        )}
    </>
  );
};

const mapStateToProps = ({ station }) => {
  const isNewStationLoading = get(station, 'isNewStationLoading', []);
  const isStationsLoading = get(station, 'isStationsLoading', []);
  const isStationsDeleteLoading = get(station, 'isStationsDeleteLoading', []);
  return {
    isNewStationLoading,
    isStationsLoading,
    isStationsDeleteLoading,
  };
};

const mapDispatchToProps = {
  onAddStation: addStation,
  onDeleteStationList: deleteSowStation,
};
export default connect(mapStateToProps, mapDispatchToProps)(AddNewPQTStation);
